import moment from "moment";
import clientService from "./clientService";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
//get user from localStaorage
const initialState = {
  dashboardDateRange: [
    new Date(
      moment().utc().subtract(30, "years").startOf("year").format()
    ).toISOString(),
    new Date(moment().utc().endOf("year").format()).toISOString(),
  ],
};

export const setClientDashboardDate = createAsyncThunk(
  "client/setClientDashboardDate",
  async (date) => {
    return await clientService.setDateRange(date);
  }
);

export const clientSlice = createSlice({
  name: "client",
  initialState,
  reducers: {
    reset: (state) => {
      state.dashboardDateRange = [
        new Date(
          moment().utc().subtract(30, "years").startOf("year").format()
        ).toISOString(),
        new Date(moment().utc().endOf("year").format()).toISOString(),
      ];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(setClientDashboardDate.fulfilled, (state, action) => {
        state.dashboardDateRange = action.payload;
      });
  },
});

export const { reset } = clientSlice.actions;
export default clientSlice.reducer;
